export function startIntercom() {
  window.Intercom?.('show');
}

export function bootIntercom(config) {
  window.Intercom?.('boot', config);
}
